<template>
	<div class="section" v-if="visible">
		<card
			v-for="item of items"
			:key="item.index"
			:card-data="item"
			:card-type="itemType"
			@click-item="$emit('click-item', $event)"
		></card>
	</div>
</template>

<script>
import Card from '@/components/card';
export default {
	components: { Card },
	props: ['items', 'itemType', 'visible'],
};
</script>

<style lang="scss">
.section {
	display: flex;
	flex-wrap: wrap;
}
</style>
